import { TutorDto } from "../../tutors/dto/tutorDto";
import { GUID } from "../../../helpers/guid.helper";

export class AddStudentDto {
    Id: string;
    FirstName: string;
    LastName: string;
    DocumentNumber: string;
    CUIL: string;
    Email: string;
    PhoneNumber: string;
    MobilePhoneNumber: string;
    AnotherContactPhone: string;
    OtherPhoneBelongs: string;
    Birthdate: string;
    Photo: string;
    IdentificationTypeId: number;
    PersonGenderId: number;
    Address: string;
    HasBrothersOfSchoolAge: boolean;
    IsActive: boolean;
    Tutor: TutorDto;
    DivisionId: number;
    IdCardFront: string;
    IdCardBack: string;
    Documentations: number[];
    Payments: any[];
    SchoolYearId: number;
    Observation: string;
    Nationality: string;
    SchoolOrigin: string;
    Location: string;

    BelongsEthnicGroup: boolean;
    EthnicName: string;
    HasHealthProblems: boolean;
    DescriptionHealthProblems: string;
    HasLegalProblems: boolean;
    DescriptionLegalProblems: string;

    FileNumber: string;
    Libro: string;
    Folio: string;
    HasSubjectsPending: boolean;
    BelongsRuralCommunity: boolean;
    RuralCommunity: string;
    HasProgresarPlan: boolean;
    HasGovernmentPC: boolean;
    HasInternet: boolean;
    PendingSubjects: string;
    

    constructor() {
        let tutorDto = new TutorDto();
        this.Id = GUID.newGuid();
        this.FirstName = 's';
        this.LastName = 'd';
        this.DocumentNumber = '2';
        this.CUIL = '';
        this.Email = '';
        this.PhoneNumber = '';
        this.MobilePhoneNumber = '';
        this.AnotherContactPhone = '';
        this.Birthdate = '2010/05/05';
        this.Photo = '';
        this.IdentificationTypeId = -1;
        this.PersonGenderId = 1;
        this.Address = '';
        this.IsActive = false;
        this.HasBrothersOfSchoolAge = null;
        this.IsActive = true;
        this.Tutor = tutorDto;
        this.DivisionId = 1;
        this.IdCardFront = '';
        this.IdCardBack = '';
        this.Documentations = [];
        this.Payments = [];
        this.SchoolYearId = undefined;
        this.Observation = '';
        this.Nationality = '';
        this.SchoolOrigin = '';
        this.Location = '';

        this.BelongsEthnicGroup = null;
        this.EthnicName = '';
        this.HasHealthProblems = null;
        this.DescriptionHealthProblems = '';
        this.HasLegalProblems = null;
        this.DescriptionLegalProblems = '';
        this.OtherPhoneBelongs = '';

        this.FileNumber = '';
        this.Libro = '';
        this.Folio = '';
        this.HasSubjectsPending = false;
        this.BelongsRuralCommunity = null;
        this.RuralCommunity = '';
        this.HasProgresarPlan = false;
        this.HasGovernmentPC = false;
        this.HasInternet = false;
        this.PendingSubjects = '';
    }
}



// WEBPACK FOOTER //
// ./src/app/main/models/students/dto/AddStudentDto.ts